import { pick } from 'lodash';
import { buildBaseClone } from '@/utilities/orderClone';

// Service-line fields copied onto the clone. Excludes service_id/order_id (fresh rows on the clone)
// and confirmed/confirmed_quantity (mobile-set execution state, starts clean on a new order).
// billable + require_confirm carry so the warranty toggle + mobile-confirm flag move with the line.
// service_time carries so the moved line's dwell follows it — the parent's stops are recalculated
// without it, so dropping it here would lose the time from both orders.
const SERVICE_CLONE_FIELDS = [
    'code',
    'type',
    'description',
    'quantity',
    'size',
    'require_confirm',
    'billable',
    'service_time',
    'metadata',
];

// Build a service-only clone of `order` carrying the SELECTED service lines, priced service-only by
// the onwardv2 isService branch. Shares buildBaseClone with the attempt-billing clone — same field
// copy + suffix + original_order_id linkage — but: order_type='service' on a normal (live) status.
// Items are intentionally NOT copied. `parent` is the ROOT order (defaults to `order`): clones link
// to it and are named as flat siblings off its number/PO, so splitting a child produces a sibling
// rather than nesting the child as a parent of its own.
export const buildServiceClone = ({ order, parent = order, priced, services, suffixIndex, instructions }) => ({
    ...buildBaseClone({ order, namingSource: parent, priced, suffixLetter: 'S', index: suffixIndex }),
    order_type: 'service',
    order_status: 'processing',
    ...(instructions ? { special_instructions: instructions } : {}),
    services: { data: (services || []).map((svc) => pick(svc, SERVICE_CLONE_FIELDS)) },
});
